var _rect, _rect2, _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailWidgetDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 49,
    fill: "#1A202C",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 41,
    x: 4,
    y: 4,
    fill: "#28313F",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#605CFF",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "M26 38h3.9M53 38h-3.2m0 0-3.3-10.7M49.8 38l-10-6.4m10 6.4h-10m-10 0 3.3-10.7M30 38l10-6.4m-10 6.4h10m-6.2-23.2h11.6m1.2 12.5-6.7 4.3m6.7-4.3h-6.7m6.7 0L44 19m-10.9 8.3 6.7 4.3m-6.7-4.3h6.7m-6.7 0 2.5-8.3m4.2 12.6V38m0-10.7L44 19m-4.2 8.3L35.6 19m8.4 0-1.3-4.2V12c0-.6-.4-1-1-1H38a1 1 0 0 0-1 1v2.8L35.6 19m8.4 0h-8.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 17,
    r: 6,
    stroke: "#D2DFFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2DFFA",
    d: "M61.8 13.8a.8.8 0 1 1-1.5 0 .8.8 0 0 1 1.5 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D2DFFA",
    d: "M61 20.3v-4.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailWidgetDark);
export default __webpack_public_path__ + "static/media/detail-widget-dark.5e9f9ea0deed770c7b74d8bd55695889.svg";
export { ForwardRef as ReactComponent };